import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

// -------------------- Save Workflow --------------------
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.SaveWorkflow.';
  public static readonly processing = `${Id.prefix}processing`;
  public static readonly saveFailed = `${Id.prefix}saveFailed`;
  public static readonly abandonChanges = `${Id.prefix}abandonChanges`;
  public static readonly stayOnDictionary = `${Id.prefix}stayOnDictionary`;
  public static readonly savingDictionary = `${Id.prefix}savingDictionary`;
  public static readonly unsavedChanges = `${Id.prefix}unsavedChanges`;
  public static readonly save = `${Id.prefix}save`;
  public static readonly abandon = `${Id.prefix}abandon`;
  public static readonly keepEditing = `${Id.prefix}keepEditing`;
  public static readonly saveChanges = `${Id.prefix}saveChanges`;
  public static readonly stayOnPage = `${Id.prefix}stayOnPage`;
}

export class LangSaveWorkflow {
  private constructor() {}
  public static processing(): string {
    return interpolate(Id.processing);
  }
  public static saveFailed(): string {
    return interpolate(Id.saveFailed);
  }
  public static abandonChanges(): string {
    return interpolate(Id.abandonChanges);
  }
  public static stayOnDictionary(dictionaryName: string): string {
    return interpolate(Id.stayOnDictionary, { dictionaryName });
  }
  public static savingDictionary(dictionaryName: string): string {
    return interpolate(Id.savingDictionary, { dictionaryName });
  }
  public static unsavedChanges(): string {
    return interpolate(Id.unsavedChanges);
  }
  public static save(): string {
    return interpolate(Id.save);
  }
  public static abandon(): string {
    return interpolate(Id.abandon);
  }
  public static keepEditing(): string {
    return interpolate(Id.keepEditing);
  }
  public static saveChanges(): string {
    return interpolate(Id.saveChanges);
  }
  public static stayOnPage(): string {
    return interpolate(Id.stayOnPage);
  }
}

export class SaveWorkflowModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.processing, 'Processing...', 'Spinner label for save in progress');
    register.add(Id.saveFailed, 'Save Failed', 'Dialog title for failed save');
    register.add(Id.abandonChanges, 'Abandon Changes', 'Button label for abandoning changes');
    register.add(
      Id.stayOnDictionary,
      'Stay On {{dictionaryName}}',
      'Button label for staying on the current dictionary'
    );
    register.add(Id.savingDictionary, 'Saving {{dictionaryName}}', 'Dialog title for saving a dictionary');
    register.add(Id.unsavedChanges, 'You have unsaved changes', 'Dialog message for unsaved changes');
    register.add(Id.save, 'Save', 'Button label for save');
    register.add(Id.abandon, 'Abandon', 'Button label for abandon');
    register.add(Id.keepEditing, 'Keep Editing', 'Button label for keep editing');
    register.add(Id.saveChanges, 'Save Changes', 'Button label for save changes');
    register.add(Id.stayOnPage, 'Stay On Page', 'Button label for staying on the page');
  }
}
